import { render, staticRenderFns } from "./HelpIndex.vue?vue&type=template&id=ed299b5c&scoped=true&"
import script from "./HelpIndex.vue?vue&type=script&lang=js&"
export * from "./HelpIndex.vue?vue&type=script&lang=js&"
import style0 from "./HelpIndex.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HelpIndex.vue?vue&type=style&index=1&id=ed299b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed299b5c",
  null
  
)

export default component.exports